import { HOT_LIST, HOT_WORDS } from "@/mocks/contents";

export default function HeroHot() {
  const marqueeList = [...HOT_LIST, ...HOT_LIST];
  const heroBg =
    "https://readdy.ai/api/search-image?query=dark%20cinematic%20editorial%20background%20with%20deep%20crimson%20and%20charcoal%20gradients%2C%20soft%20amber%20bokeh%20stage%20lights%20and%20gentle%20motion%20blur%2C%20premium%20moody%20media%20aesthetic%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-band-2026&orientation=landscape";

  return (
    <section id="home" aria-label="首屏">
      <div className="relative isolate flex min-h-[520px] w-full flex-col justify-center overflow-hidden bg-foreground-950">
        <img
          src={heroBg}
          alt="吃瓜嘿料热点门户首屏背景"
          className="absolute inset-0 h-full w-full object-cover object-center opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/40 to-foreground-950/90" aria-hidden="true"></div>

        <div className="relative mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/50 bg-primary-500/15 px-3 py-1 text-xs font-semibold text-primary-100">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
              </span>
              全网热点 · 实时速览
            </span>

            <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
              吃瓜吃到底，
              <br className="hidden sm:block" />
              <span className="text-primary-300">真相不遗漏。</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
              吃瓜嘿料为你聚合实锤证据与石锤图文，把散落各处的录音、聊天记录、视频与官方回应，整理成清晰的时间线与内容卡片。热点怎么看、信源怎么核、后续怎么跟，这里一次看全。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#hotlist"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                围观今日热榜
                <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
              </a>
              <a
                href="#feature"
                className="inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-background-300/40 bg-background-50/5 px-6 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-background-50/15"
              >
                看深度盘点
              </a>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-2">
              <span className="text-xs font-medium text-background-200/70">正在发酵：</span>
              {HOT_WORDS.map((w) => (
                <a
                  key={w}
                  href="#hotlist"
                  className="cursor-pointer whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  #{w}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="relative border-t border-background-50/10">
          <div className="mx-auto flex w-full max-w-7xl items-center gap-3 px-4 py-3 md:px-6">
            <span className="flex shrink-0 items-center gap-1.5 text-xs font-bold tracking-wide text-accent-400">
              <i className="ri-fire-line text-sm" aria-hidden="true"></i>
              24H 热瓜速递
            </span>
            <div className="relative flex-1 overflow-hidden">
              <div className="animate-marquee flex w-max items-center gap-10 pr-10">
                {marqueeList.map((item, idx) => (
                  <span key={idx} className="flex items-center gap-2 whitespace-nowrap text-sm text-background-100/80">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-400" aria-hidden="true"></i>
                    {item.title}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}